// ==================== SERVICIO DE SECCIONES DE SUBCONTRATOS ====================
// Maneja todas las operaciones CRUD de secciones de subcontratos

import api from './api';

const seccionesSubcontratosService = {
  // ==================== OBTENER TODAS LAS SECCIONES ====================
  async obtenerSecciones() {
    try {
      const response = await api.get('/secciones');
      return response.data.secciones || [];
    } catch (error) {
      console.error('Error al obtener secciones de subcontratos:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener secciones' };
    }
  },

  // ==================== OBTENER UNA SECCIÓN ====================
  async obtenerSeccion(idSeccion) {
    try {
      const response = await api.get(`/secciones/${idSeccion}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener sección de subcontrato:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener sección' };
    }
  },

  // ==================== CREAR SECCIÓN ====================
  async crearSeccion(datosSeccion) {
    try {
      const response = await api.post('/secciones', datosSeccion);
      return response.data.seccion;
    } catch (error) {
      console.error('Error al crear sección de subcontrato:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al crear sección' };
    }
  },

  // ==================== ACTUALIZAR SECCIÓN ====================
  async actualizarSeccion(idSeccion, datosActualizados) {
    try {
      const response = await api.put(`/secciones/${idSeccion}`, datosActualizados);
      return response.data.seccion;
    } catch (error) {
      console.error('Error al actualizar sección de subcontrato:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al actualizar sección' };
    }
  },

  // ==================== ELIMINAR SECCIÓN ====================
  async eliminarSeccion(idSeccion) {
    try {
      const response = await api.delete(`/secciones/${idSeccion}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar sección de subcontrato:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al eliminar sección' };
    }
  },

  // ==================== OBTENER ESTADÍSTICAS ====================
  async obtenerEstadisticas(idSeccion) {
    try {
      const response = await api.get(`/secciones/${idSeccion}/estadisticas`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas de sección:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener estadísticas' };
    }
  }
};

export default seccionesSubcontratosService;
